/**
 * Entry point for content provider plugin.
 * Consists of API initializer for Prime Launcher.
 */

'use strict';

module.exports = {
    /** Initialization of API provider for external (Prime Launcher for now) subscriber. */
    onContentBoardInit: require('./modules/launcher.api.provider')
};
